export default __webpack_public_path__ + "static/media/pago-bancomat.a8807b6a.svg";